import React from 'react';
import styled, { css } from 'styled-components';
import { ButtonType } from 'component-library-and-tools';
import { ReactComponent as WorkflowSVG } from '../../assets/workflow.svg';
import { generateAuthUrl } from '../../utils';

import Button from 'shared/components/Button';
import { DARK_THEME } from 'shared/constants';
import { colors } from 'lib/prisma-styles';

const StyledColumnFlexDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const StyledLoginContainer = styled.div<{loading: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.08), 0 2px 6px 0 rgba(0,0,0,0.16);
    padding: 2.5rem 0;
    border-radius: 4px;

    height: 23rem;
    width: 22.5rem;

    transition: opacity 0.2s ease;

    ${props => props.loading && props.theme.mode !== DARK_THEME && css`{
        opacity: 0.6;
    }`}

    h1 {
        text-align: center;
        margin-top: 0rem;
    }

    button {
        background-color: ${colors.interactive.primaryAction};
        width: 15rem;
        margin-bottom: 0.3rem;
    }

    *:not(button) {
      user-select: none;
    }

    ${StyledColumnFlexDiv}:last-of-type {
        margin-top: 4rem;
    }
`;


const StyledWorkflowSVG = styled(WorkflowSVG)`
    width: 10rem;
    height: 8rem;
    margin-bottom: 1rem;

    g * {
        stroke: ${colors.interactive.primaryAction};
    }
`;

const LoginBox = (props: { loading: boolean }) => {
    const { loading } = props;
    
    return (
        <StyledLoginContainer loading={loading}>
            <StyledColumnFlexDiv>
                <StyledWorkflowSVG />
                <span>Splunk + TruSTAR</span>
                <h1> Workflows </h1>
            </StyledColumnFlexDiv>
            <StyledColumnFlexDiv>
                <Button
                    isLoading={loading}
                    label="Login to Workflows"
                    type={ButtonType.PRIMARY}
                    onClick={goToLogin}
                />
                <span>Via TruSTAR Station</span>
            </StyledColumnFlexDiv>
        </StyledLoginContainer>
    );
};

const goToLogin = () => {
    window.location.href = generateAuthUrl();
};

export {LoginBox};